var installedModules = {};
var moduleToHandlerMapping = {
	2597: {
		getter: () => (__webpack_require__.e(644).then(() => (() => (__webpack_require__(4041))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	6699: {
		getter: () => (Promise.all([__webpack_require__.e(644), __webpack_require__.e(96)]).then(() => (() => (__webpack_require__(3144))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	2852: {
		getter: () => (Promise.all([__webpack_require__.e(874), __webpack_require__.e(96)]).then(() => (() => (__webpack_require__(9317))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ant-design/icons",
	},
	9373: {
		getter: () => (Promise.all([__webpack_require__.e(874), __webpack_require__.e(96), __webpack_require__.e(699)]).then(() => (() => (__webpack_require__(9068))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.12.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "antd",
	},
	2411: {
		getter: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(699)]).then(() => (() => (__webpack_require__(8955))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.20.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	5840: {
		getter: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(517), __webpack_require__.e(791)]).then(() => (() => (__webpack_require__(9915))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.181",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "sysone-api-mapper",
	},
	7861: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(275))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	810: {
		getter: () => (Promise.all([__webpack_require__.e(644), __webpack_require__.e(96)]).then(() => (() => (__webpack_require__(6608))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	7517: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(7340))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.6.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "axios",
	},
	5968: {
		getter: () => (__webpack_require__.e(432).then(() => (() => (__webpack_require__(4432))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@customer-platform/shared",
	},
	900: {
		getter: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(7394))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	7791: {
		getter: () => (Promise.all([__webpack_require__.e(644), __webpack_require__.e(96)]).then(() => (() => (__webpack_require__(5517))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"212": [
		2852,
		9373
	],
	"354": [
		2411,
		5840,
		7861
	],
	"517": [
		7517
	],
	"597": [
		2597
	],
	"623": [
		5968,
		900
	],
	"699": [
		6699
	],
	"791": [
		7791
	],
	"810": [
		810
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}